export const SET_MENU = 'SET_MENU';
export const SET_DEMO = 'SET_DEMO';
